import React from 'react';
import styled from 'styled-components';

import { Heading } from 'core/ui/atoms';

const SlideTitle = styled((p) => <Heading {...p} />)`
  font-weight: bold;
  font-size: 34px;
  line-height: 41px;
  text-align: center;
  letter-spacing: -0.02em;
  color: ${(p) => p.theme.colors.black};
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
  margin: 0 0 30px;
  ${(p) => p.theme.max('sm')`
    font-size: 28px;
    line-height: 34px;
    margin: 0 0 20px;
  `};
`;

export default SlideTitle;
